import angular from 'angular';
import './app.module';

function configureApp($locationProvider, $compileProvider) {
  $locationProvider.html5Mode(true);
  $compileProvider.debugInfoEnabled(true);
}

configureApp.$inject = ['$locationProvider', '$compileProvider'];

angular.module('app').config(configureApp);
